import React from "react";
import type { InputProps } from "@material-ui/core/Input";
import * as MuiInput from "@material-ui/core/Input";
import { createStyles, withStyles } from "@material-ui/core/styles";

import type { CoretexTheme } from "../theme";

const Mui = MuiInput.default;
const InputOverride = (props: InputProps) => <Mui {...props} disableUnderline />;

const styles = (theme: CoretexTheme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.mono.gray}`,
    boxSizing: "border-box",
    borderRadius: 50,
    paddingLeft: "1em",
    "&.Mui-focused": { border: `1px solid ${theme.palette.colour.primaryBlue}` },
  },
});

const InputRounded: React.ComponentType<InputProps> = withStyles(createStyles(styles))(InputOverride);

export default InputRounded;
